import { React, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { GetUser, addworkspacePermission, getPermissionByUid } from "../ApiServices/apiHandler";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";


import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import modifyAccess from "../../../myfin_v2/css/modifyAccess.module.css"
import Breadcrumb from "../../../myfin_v2/components/Breadcrumb"
import { Button } from "../../../myfin_v2/elements/Button"
import { ReactComponent as CircleCheck } from '../../../myfin_v2/assets/icons/circle_checkdark.svg';
import { ReactComponent as CrossGrey } from '../../../myfin_v2/assets/icons/crossGrey.svg';
import DefaultUserRound from "../../../myfin_v2/assets/imgs/DefaultUserRound.png";
import "../../Workspace2/sidebar.css";

const ModifyAccess = () => {
    let history = useHistory();
    let { uid, wid } = useParams();
    const user = JSON.parse(localStorage.getItem('user'));
    const modifyAccess_action = localStorage.getItem("modifyAccess");
    const [allUser, setAllUser] = useState([]);
    const targetIsAdmin = allUser.some((member) => member._id === uid && member.isAdmin === "Yes");
    const [permissions, setPermissions] = useState('');
    const [accessStatus, setAccessStatus] = useState({
        editworkspace_name: false,
        addcompanies: false,
        addregisters: false,
        addpresets: false,
        addteam_member: false
    });

    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const triggerSuccessPopup = (msg) => {
        setSuccessMessage(msg);
        setShowSuccessPopup(true);
    };

    const triggerErrorPopup = (msg) => {
        setErrorMessage(msg);
        setShowErrorPopup(true);
    };

    useEffect(() => {
        GetAllUser();
        getPermission();
    }, []);


    const handleChange = (value, field) => {
        if (field === "addteam_member" && targetIsAdmin) return;
        if (permissions) {
            setPermissions((prev) => ({ ...prev, [field]: value }));
        }
        setAccessStatus((prev) => ({ ...prev, [field]: value }));
    };

    const getPermission = async () => {
        try {
            const workspace_id = wid;
            const user_id = uid;
            const res = await getPermissionByUid(workspace_id, user_id);
            if (res.status === 200 && res.data?.response?.workspace_access) {
                const wsAccess = res.data.response.workspace_access[0];
                if (wsAccess) {
                    setPermissions(wsAccess);
                    setAccessStatus({
                        editworkspace_name: Boolean(wsAccess.editworkspace_name),
                        addcompanies: Boolean(wsAccess.addcompanies),
                        addregisters: wsAccess.addregisters !== undefined ? Boolean(wsAccess.addregisters) : Boolean(wsAccess.addcompanies),
                        addpresets: wsAccess.addpresets !== undefined ? Boolean(wsAccess.addpresets) : Boolean(wsAccess.addcompanies),
                        addteam_member: Boolean(wsAccess.addteam_member)
                    });
                }
            } else {
                triggerErrorPopup("Get Permission Failed");
            }
        } catch (error) {
            console.error("Get Permission Failed:", error);
            triggerErrorPopup("Get Permission Failed");
        }
    }

    const GetAllUser = async () => {
        const res = await GetUser();
        if (res.status === 200) {
            setAllUser(res.data.fetchUser);
        }
    };
    const addpermission = async () => {
        const currentEditName = permissions?.editworkspace_name !== undefined ? permissions.editworkspace_name : accessStatus.editworkspace_name;
        const currentAddCompanies = permissions?.addcompanies !== undefined ? permissions.addcompanies : accessStatus.addcompanies;
        const currentAddRegisters = permissions?.addregisters !== undefined ? permissions.addregisters : accessStatus.addregisters;
        const currentAddPresets = permissions?.addpresets !== undefined ? permissions.addpresets : accessStatus.addpresets;
        const currentAddTeam = permissions?.addteam_member !== undefined ? permissions.addteam_member : accessStatus.addteam_member;

        const data = {
            user_id: uid,
            workspace_id: wid,
            editworkspace_name: Boolean(currentEditName),
            addcompanies: Boolean(currentAddCompanies),
            addregisters: Boolean(currentAddRegisters),
            addpresets: Boolean(currentAddPresets),
            addteam_member: targetIsAdmin ? true : Boolean(currentAddTeam)
        };

        addworkspacePermission(data)
            .then(response => {
                if (response.status === 200) {
                    triggerSuccessPopup("Workspace permission given Successfully");
                    getPermission();
                } else {
                    triggerErrorPopup("Failed to give workspace permission");
                }
            })
            .catch(error => {
                triggerErrorPopup("Failed to give workspace permission");
                console.error("Failed to give workspace permission:", error);
            });
    }

    const userName = (u_id) => {
        try {
            const nameUser = allUser.filter((adj) => adj._id === u_id);
            const result = nameUser[0]?.name ? nameUser[0]?.name : "";
            return result;
        } catch (error) {
            console.log(error, "2222");
            return 0;
        }
    };

    const userEmail = (u_id) => {
        try {
            const nameUser = allUser.filter((adj) => adj._id === u_id);
            const result = nameUser[0]?.email ? nameUser[0]?.email : "";
            return result;
        } catch (error) {
            console.log(error, "2222");
            return 0;
        }
    };

    const breadcrumbItems = [
        {
            label: "Workspace Team Members",
            link: `/${modifyAccess_action}/${wid}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Manage Team Members",
            link: `/${modifyAccess_action}/${wid}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "Modify Access", link: "", className: "headerLable" },
    ];


    return (
        <>
            <div className={`ml-0 mr-0 ${commoncss.pageLayout}`}>
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <div className={modifyAccess.modifyAccessLayout}>
                        <Breadcrumb
                            addCls={"bgClr1"}
                            items={breadcrumbItems}
                            headerActions={<></>}
                        />
                        <div className={modifyAccess.contentLayout}>
                            <div className="w-100">
                                <div className={commoncss.dFlexJustifysb} style={{ "width": "100%", "padding": "25px" }}>
                                    <div style={{ "font-size": "16px", display: "flex", alignItems: "center", gap: "10px" }}>
                                        <img
                                            src={DefaultUserRound}
                                            className={modifyAccess.bkclUserImg}
                                            alt="user"
                                        />
                                        <div className={modifyAccess.multiLabel}>
                                            <span className={modifyAccess.profileName}>{userName(uid)}</span>
                                            <span className={modifyAccess.emailLabel}>{userEmail(uid)}</span>
                                        </div>
                                    </div>
                                </div>
                                <hr className="m-0" />
                                <div className={wsCreationcss.modifyAccess}>
                                    <div className={wsCreationcss.wsAccess}>
                                        <div className={commoncss.dFlexClm}>
                                            <span className={wsCreationcss.wscHeading2}>Workspace Settings</span>
                                            <span className={`${wsCreationcss.wscLabel8} mt-1`}>Define access to workspace-level actions like editing team members, company details, registers, and presets</span>
                                        </div>
                                        <hr />
                                        <div>

                                            <div className="toggle-item">
                                                <div className={`toggle-container`}>
                                                    <label className="switch">
                                                        <input type="checkbox"
                                                            value={permissions ? permissions.editworkspace_name : accessStatus.editworkspace_name}
                                                            checked={Boolean(permissions ? permissions.editworkspace_name : accessStatus.editworkspace_name)}
                                                            disabled={user?.responsibilities === "approver"}
                                                            onChange={(e) =>
                                                                handleChange(e.target.checked, "editworkspace_name")
                                                            }
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label className={wsCreationcss.wscLabel2} >Edit Workspace Name & Date</label>
                                                    {Boolean(permissions ? permissions.editworkspace_name : accessStatus.editworkspace_name) ? (
                                                        <label className={modifyAccess.accessGrantedLabel}>
                                                            <CircleCheck height={18} /> Access Granted
                                                        </label>
                                                    ) : (
                                                        <label className={modifyAccess.accessDeniedLabel}>
                                                            <CrossGrey height={18} /> Access Denied
                                                        </label>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="toggle-item mt-4">
                                                <div className={`toggle-container`}>
                                                    <label className="switch">
                                                        <input type="checkbox"
                                                            value={permissions ? permissions.addcompanies : accessStatus.addcompanies}
                                                            checked={Boolean(permissions ? permissions.addcompanies : accessStatus.addcompanies)}
                                                            disabled={user?.responsibilities === "approver"}
                                                            onChange={(e) =>
                                                                handleChange(e.target.checked, "addcompanies")
                                                            }
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label className={wsCreationcss.wscLabel2} >Add Companies</label>
                                                    {Boolean(permissions ? permissions.addcompanies : accessStatus.addcompanies) ? (
                                                        <label className={modifyAccess.accessGrantedLabel}>
                                                            <CircleCheck height={18} /> Access Granted
                                                        </label>
                                                    ) : (
                                                        <label className={modifyAccess.accessDeniedLabel}>
                                                            <CrossGrey height={18} /> Access Denied
                                                        </label>
                                                    )}

                                                </div>
                                            </div>

                                            <div className="toggle-item mt-4">
                                                <div className={`toggle-container`}>
                                                    <label className="switch">
                                                        <input type="checkbox"
                                                            value={permissions ? permissions.addregisters : accessStatus.addregisters}
                                                            checked={Boolean(permissions ? permissions.addregisters : accessStatus.addregisters)}
                                                            disabled={user?.responsibilities === "approver" || !Boolean(permissions ? permissions.addcompanies : accessStatus.addcompanies)}
                                                            onChange={(e) =>
                                                                handleChange(e.target.checked, "addregisters")
                                                            }
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label className={wsCreationcss.wscLabel2} >Edit Registers</label>
                                                    {Boolean(permissions ? permissions.addregisters : accessStatus.addregisters) ? (
                                                        <label className={modifyAccess.accessGrantedLabel}>
                                                            <CircleCheck height={18} /> Access Granted
                                                        </label>
                                                    ) : (
                                                        <label className={modifyAccess.accessDeniedLabel}>
                                                            <CrossGrey height={18} /> Access Denied
                                                        </label>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="toggle-item mt-4">
                                                <div className={`toggle-container`}>
                                                    <label className="switch">
                                                        <input type="checkbox"
                                                            value={permissions ? permissions.addpresets : accessStatus.addpresets}
                                                            checked={Boolean(permissions ? permissions.addpresets : accessStatus.addpresets)}
                                                            disabled={user?.responsibilities === "approver" || !Boolean(permissions ? permissions.addcompanies : accessStatus.addcompanies)}
                                                            onChange={(e) =>
                                                                handleChange(e.target.checked, "addpresets")
                                                            }
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label className={wsCreationcss.wscLabel2} >Edit Presets & COA</label>
                                                    {Boolean(permissions ? permissions.addpresets : accessStatus.addpresets) ? (
                                                        <label className={modifyAccess.accessGrantedLabel}>
                                                            <CircleCheck height={18} /> Access Granted
                                                        </label>
                                                    ) : (
                                                        <label className={modifyAccess.accessDeniedLabel}>
                                                            <CrossGrey height={18} /> Access Denied
                                                        </label>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="toggle-item mt-4">
                                                <div className={`toggle-container`}>
                                                    <label className="switch">
                                                        <input type="checkbox"
                                                            value={targetIsAdmin || Boolean(permissions ? permissions.addteam_member : accessStatus.addteam_member)}
                                                            checked={targetIsAdmin || Boolean(permissions ? permissions.addteam_member : accessStatus.addteam_member)}
                                                            disabled={targetIsAdmin || user?.responsibilities === "approver"}
                                                            onChange={(e) =>
                                                                handleChange(e.target.checked, "addteam_member")
                                                            }
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label className={wsCreationcss.wscLabel2} >Add Team Members</label>
                                                    {targetIsAdmin || Boolean(permissions ? permissions.addteam_member : accessStatus.addteam_member) ? (
                                                        <label className={modifyAccess.accessGrantedLabel}>
                                                            <CircleCheck height={18} /> Access Granted
                                                        </label>
                                                    ) : (
                                                        <label className={modifyAccess.accessDeniedLabel}>
                                                            <CrossGrey height={18} /> Access Denied
                                                        </label>
                                                    )}
                                                </div>
                                            </div>
                                            
                                            <Button
                                                label="Save"
                                                style={{ marginTop:"30px" }}
                                                btnColor={buttoncss.primary}
                                                disabled={user?.responsibilities==="approver"}
                                                onClick={addpermission}
                                            />

                                        </div>
                                    </div>
                                    <div className={wsCreationcss.funcAccess}>
                                        <div className={commoncss.dFlexClm}>
                                            <span className={wsCreationcss.wscHeading2}>Functionality Access</span>
                                            <span className={`${wsCreationcss.wscLabel8} mt-1`}>Manage access for each company and select the modules your teammate can work on </span>
                                        </div>
                                        <hr className="" style={{ "margin-top": "36px" }} />
                                        <div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <SuccessPopup
                isOpen={showSuccessPopup}
                message={successMessage}
                onClose={() => setShowSuccessPopup(false)}
            />
            <ErrorPopup
                isOpen={showErrorPopup}
                message={errorMessage}
                onClose={() => setShowErrorPopup(false)}
            />
        </>

    );
};

export default ModifyAccess;
